module.exports = __webpack_public_path__ + "img/shutterstock_133553759.1d58b4df.png";